var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7398 3.974c-.0568-.213-.1723-.44-.2576-.6386C9.4605.88 7.228 0 5.4255 0 3.0125 0 .3548 1.618 0 4.9532v.6814c0 .0284.0098.2839.0237.4117.199 1.5894 1.4531 3.2787 2.3898 4.8681 1.0078 1.703 2.0534 3.3782 3.0894 5.0527.6388-1.0928 1.2753-2.1999 1.8996-3.2644.1701-.3124.3676-.6246.538-.9227.1135-.1986.3303-.3971.4294-.5818 1.0077-1.845 2.6297-3.7042 2.6297-5.5352v-.7522c0-.1985-.246-.894-.2598-.9367ZM5.4697 7.3947c-.7093 0-1.4857-.3546-1.869-1.3341-.057-.156-.0524-.4684-.0524-.497v-.44c0-1.2487 1.0602-1.8165 1.9826-1.8165 1.1355 0 2.0137.9085 2.0137 2.044s-.9394 2.0436-2.0749 2.0436Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default ForwardRef;